module.exports = __webpack_public_path__ + "static/media/13.ed5104f4.jpg";